import React from 'react';
import styled from 'styled-components';
import {FormSection, reduxForm} from 'redux-form';
import {
    DOCUMENTATION_UPDATE_SECTION,
    FORM_ATTACHMENTS_SECTION,
    FORM_MESSAGES_SECTION,
    FORM_PROBLEM_DESCRIPTION_SECTION,
    FORM_TICKET_SECTION,
    FORM_VEHICLE_DETAIL_SECTION,
} from '../../../../constants/formConstants';
import RenderSyncErrors from '../../../common/RenderSyncErrors';
import formMessages from '../../../../intl/afterSales/formMessages';
import {aseFieldLabelMapping} from '../../../../constants/aseFieldLabelMapping';
import PropTypes from 'prop-types';
import SubmitButtons from './sections/SubmitButtons';
import {scrollContentWrapperToTop} from '../../../../utils/utils';

import RequestorInformationMaintenanceSection from './sections/maintenance/RequestorInformationMaintenanceSection';
import VehicleDetailMaintenanceSection from './sections/maintenance/VehicleDetailMaintenanceSection';
import ProblemDescriptionMaintenanceSection from './sections/maintenance/ProblemDescriptionMaintenanceSection';
import AttachmentSection from './sections/attachments/AttachmentSection';
import InternalNotes from './sections/internalNotes/InternalNotes';
import DocumentationUpdateMaintenanceSection from './sections/maintenance/DocumentationUpdateMaintenanceSection';
import TicketStatusHistory from '../../../common/TicketStatusHistory';

const StyledDiv = styled.div`
  border-radius: 10px;
  background-color: #FFFAE6!important;
`;

const InternalMaintenanceTicketMasterForm = (props) => {
    const {form, userRights, readOnly, handleSubmit, reqFields} = props;

    return (
        <StyledDiv className="border border-dark p-4">
            <RenderSyncErrors form={form} intlMessages={formMessages} mapping={aseFieldLabelMapping}/>
            <FormSection name={FORM_TICKET_SECTION}>
                <RequestorInformationMaintenanceSection
                    form={form}
                    userRights={userRights}
                    reqFields={reqFields}
                    readOnly={readOnly}
                />
            </FormSection>
            <FormSection name={FORM_VEHICLE_DETAIL_SECTION}>
                <VehicleDetailMaintenanceSection
                    form={form}
                    userRights={userRights}
                    reqFields={reqFields}
                    readOnly={readOnly}
                />
            </FormSection>
            <FormSection name={FORM_PROBLEM_DESCRIPTION_SECTION}>
                <ProblemDescriptionMaintenanceSection
                    form={form}
                    userRights={userRights}
                    reqFields={reqFields}
                    readOnly={readOnly}
                />
            </FormSection>
            <FormSection name={FORM_ATTACHMENTS_SECTION}>
                <AttachmentSection
                    form={form}
                    userRights={userRights}
                    readOnly={readOnly}
                />
            </FormSection>
            {userRights.canShowInternalNotes &&
                <FormSection name={FORM_MESSAGES_SECTION}>
                    <InternalNotes
                        form={form}
                        userRights={userRights}
                        reqFields={reqFields}
                        readOnly={readOnly}
                    />
                </FormSection>
            }
            {userRights.canShowInternalDocumentationUpdate &&
                <FormSection name={DOCUMENTATION_UPDATE_SECTION}>
                    <DocumentationUpdateMaintenanceSection
                        form={form}
                        userRights={userRights}
                        reqFields={reqFields}
                        readOnly={readOnly}
                    />
                </FormSection>
            }
            <TicketStatusHistory form={form} isInternal/>
            <SubmitButtons
                form={form}
                onSubmit={handleSubmit}
                onSubmitFail={scrollContentWrapperToTop}
                userRights={userRights}
                readOnly={readOnly}
            />
        </StyledDiv>
    );
};

InternalMaintenanceTicketMasterForm.propTypes = {
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func,
    readOnly: PropTypes.bool,
    userRights: PropTypes.object.isRequired,
    reqFields: PropTypes.array.isRequired,
};

export default reduxForm({})(InternalMaintenanceTicketMasterForm);
